import { FieldConfig, TextConfig } from '@qfa/forms';
import { useTranslation } from 'react-i18next';
import { isEqual } from 'lodash';

import { useLocationTypeField } from './useLocationTypeField';
import { useEffect, useMemo } from 'react';
import { LocationFormValues } from '../../types';
import { useForm } from 'kineticUtils';

export const useLocationDetailsForm = (
  initialData: Partial<LocationFormValues> | undefined,
  hasPrivilege: boolean
) => {
  const { t } = useTranslation(['locations', 'common']);

  const locationTypeField = useLocationTypeField();

  const fields = useMemo(() => {
    const detailsFields: FieldConfig<LocationFormValues>[] = [
      TextConfig({
        id: 'name',
        name: 'name',
        required: true,
        label: t('common:name'),
      }),
      TextConfig({
        id: 'description',
        name: 'description',
        required: false,
        label: t('common:description'),
      }),
      locationTypeField,
    ];

    return detailsFields;
  }, [locationTypeField, t]);

  const {
    props: formProps,
    values: [values, setValues, reset],
    errors: [_hasErrors, errorMessages],
    dirty: [isDirty, _, setDirty],
    isSaveDisabled,
  } = useForm<LocationFormValues>({
    readOnly: !hasPrivilege,
    fields,
    defaultValues: {
      ...initialData,
    },
  });

  useEffect(
    () => {
      if (!isEqual(initialData, values)) {
        reset(initialData);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [initialData]
  );

  return {
    formProps,
    errorMessages,
    isDirty,
    setDirty,
    values: [values, setValues] as const,
    isSaveDisabled,
  };
};
